// filenameFromContentDisposition lấy tên file server đã đặt trong header, để FE
// không phải tự ghép lại tên (hai nguồn sự thật sẽ lệch nhau khi server chuẩn
// hóa tham số). Trả undefined nếu header thiếu hoặc không có filename.
export function filenameFromContentDisposition(
    header: string | undefined,
): string | undefined {
    if (!header) return undefined

    // filename* (RFC 5987) ưu tiên hơn vì mang được ký tự ngoài ASCII.
    const extended = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header)
    const plain = /filename="([^"]*)"|filename=([^;]+)/i.exec(header)
    const raw = extended?.[1] ?? plain?.[1] ?? plain?.[2]
    if (!raw) return undefined

    let decoded = raw.trim()
    try {
        decoded = decodeURIComponent(decoded)
    } catch {
        // Percent-encoding hỏng → dùng nguyên chuỗi thô, vẫn hơn là không tải.
    }
    // Cắt bỏ phần đường dẫn: server bị lỗi (hoặc bị chèn) không được quyết định
    // file nằm ở đâu trên máy người dùng.
    const base = decoded.split(/[/\\]/).pop()?.trim()
    return base ? base : undefined
}

// downloadBlob lưu 1 Blob về máy dưới tên file cho trước. Dùng chung cho mọi
// luồng tải file nhị phân từ API (chốt sổ, thống kê biến động…).
export function downloadBlob(blob: Blob, filename: string) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
}
